import React from 'react';

import SearchTeaser from '../../../components/SearchTeaser';
import FaqItemDetail from './Detail';

const NodeFaqItem = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'search_teaser':
      return <SearchTeaser entity={entity} />;
    case 'full':
    default:
      return <FaqItemDetail entity={entity} />;
  }
};

export default NodeFaqItem;
